
// import q 		from 'Utils/q';
import Block 	from 'Mixins/Block';

export default Block('component-socialbar', {

	onLoad () {
		const _this = this;
		const container = document.querySelector( _this.selector );
		const socialFeedButton = document.querySelector( '.component-socialbar__toggle-socialfeed' );

		if ( !container || !socialFeedButton) {return;}
		const menu = container.querySelector( 'ul' );
		socialFeedButton.addEventListener('click', function (e) {
			e.preventDefault();
			menu.classList.toggle( 'open' );
			socialFeedButton.classList.toggle( 'open' );
		});
	}

});
